import { useDeviceType } from '@cian/ui-kit';

import { type FC, useMemo } from 'react';

import { type TMainpageBrandContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';
import { useApplicationContext } from 'shared/utils/applicationContext/applicationContext';
import { useMainPageBrandBannerEnrichments } from 'shared/hooks/useMainPageBrandBannerEnrichments';

import { getMainpageBrandCompleteContext } from './internal/utils/getMainpageBrandCompleteContext';
import { MainpageBrandDesktop } from './internal/components/MainpageBrandDesktop';
import { MainpageBrandDesktopLegacy } from './internal/components/MainpageBrandDesktopLegacy';
import { MainpageBrandMobileExperiment } from './internal/components/MainpageBrandMobileExperiment';

type TMainpageBrandContainerProps = {
  context: TMainpageBrandContext;
};

export const MainpageBrandContainer: FC<TMainpageBrandContainerProps> = ({ context }) => {
  const { config } = useApplicationContext();

  const deviceType = useDeviceType();

  const isDesktopLegacyDesign = !!config.get<boolean>('MarTech.MainpageBrandDesktopLegacyDesign.Enabled');

  const { sizes } = useAdfoxBannerContext();

  const enrichments = useMainPageBrandBannerEnrichments(context);

  const completeContext = useMemo(
    () => getMainpageBrandCompleteContext({ context, enrichments, sizes }),
    [context, enrichments, sizes],
  );

  if (deviceType === 'desktop') {
    return isDesktopLegacyDesign ? (
      <MainpageBrandDesktopLegacy completeContext={completeContext} />
    ) : (
      <MainpageBrandDesktop completeContext={completeContext} />
    );
  }

  // Мобильная ветка под A/B: контроль (A) — текущий дизайн, B — новый.
  return <MainpageBrandMobileExperiment completeContext={completeContext} />;
};
